import React from 'react';
import { ToastsContainer } from '@/components/ToastsContainer';
import HeroLayout from '@/components/shared/hero/HeroLayout';

const HomeHeroContainer = ({
  children,
  isAuthenticated,
}: {
  children: React.ReactNode;
  isAuthenticated: boolean;
}): JSX.Element => {
  return (
    <HeroLayout isAuthenticated={isAuthenticated}>
      <ToastsContainer />
      <div className="z-[10] flex w-full justify-center py-8 lg:py-16">{children}</div>
    </HeroLayout>
  );
};

export default HomeHeroContainer;
